let valuelist = [
  {
    image: "integrity",
    value: "Integrity",
    content: [
      "Fairness, transparency and honesty in our conduct",
      "Upholding highest of ethical standards in our deals.",
    ],
  },
  {
    image: "creativity",
    value: "Creativity",
    content: [
      " We create an environment where employees can think big and have fun",
      "With our minds afresh our work brings out new and innovative solutions",
    ],
  },
  {
    image: "trust",
    value: "Trust",
    content: [
      "Our loyalty towards our clients is paramount and our honesty and dedication knows no bounds",
    ],
  },
  {
    image: "dedication",
    value: "Dedication",
    content: [
      "Our passion for work helps us to put consistent efforts",
      "Our dedicated efforts brings the best solutions",
    ],
  },
  {
    image: "solution",
    value: "Solution Based Approach",
    content: [
      "We understand our client's requirement and direct our efforts in fulfilling them",
      "We assure to find the best possible solution",
    ],
  },
  {
    image: "client",
    value: "Client Centric Approach",
    content: ["Our clients are our top-most priority. Always!"],
  },
];

export default valuelist;
